module.exports = __webpack_public_path__ + "img/Churned customers Icon - charcoal.98d36432.svg";